module.exports = __webpack_public_path__ + "img/82.28b1f947.png";